<template>
  <div id="app" v-if="loading">
    <mask-dialog :showMask="token === null" url="index"></mask-dialog>
    <div class="container white-back" v-if="is_auth === 0">
      <div class="text-center font-18 font-weight-bold ">GET CASH</div>
      <div class="text-center font-16 font-weight-500 margin-top-34 margin-bottom-16">HURRAAAY!</div>
      <div class="text-center margin-bottom-16">
        <img src="https://imgs.hdjfg.com/gift/img/cash-flower.png" style="width:110px" />
      </div>
      <div class="text-center font-16 margin-bottom-16" style="padding:0px 20px">
        by completing your peodile,you can
        cash up to
      </div>
      <div class="text-center font-36 font-weight-bold">
        ₹300000.00
      </div>
      <div class="flex flex-justify-between margin-top-36">
        <div class="font-16 font-weight-bold "
          style="color:#FF5D00;padding:12px 51px;background-color: #FFE8DB;border-radius: 24px;" @click="home">
          HOME
        </div>
        <div class="font-16 font-weight-bold white"
          style="padding:12px 21px;background-color: #FF5D00;border-radius: 24px;" @click="profile">
          MY PROFILE
        </div>
      </div>
    </div>
    <div class="container white-back" v-else-if="is_first === 0 && is_auth === 1">
      <div class="text-center font-18 font-weight-bold ">GET CASH</div>
      <div class="text-center font-16 font-weight-500 margin-top-34 margin-bottom-16">GREAT</div>

      <div class="text-center font-16 margin-bottom-16" style="padding:0px 20px;margin-bottom: 32px;">
        we now know all about you.
        go apply for a loan
      </div>
      <span class="font-16 font-weight-bold white"
        style="padding:12px 21px;background-color: #FF5D00;border-radius: 24px;width: 140px;" @click="apply">
        GO APPLY
      </span>
    </div>
    <div style="background: #F9F9F9;" v-else-if="is_repay === 1">
      <div class="repayment-box" v-for="(item,index) in productList" :key="item.product_id">
        <div class="repayment-title flex flex-justify-between flex-align-center" :style="getBackGroundColor(index)">
          <div class="font-20 font-weight-bold">
            {{ item.product_name }}
          </div>
          <div class="font-weight-500 white repayment-btn font-14" style="background:#DEE1E6" v-if="item.status === 0">
            Under review
          </div>
          <div class="font-weight-500 white repayment-btn font-14" :style="getColorBackGroundColor(index)"
            @click="apply2(item.product_id)" v-else>
            Withdraw Now
          </div>
        </div>
        <div class="repayment-content">
          <div class="flex flex-justify-between flex-align-center">
            <div class="text-center">
              <div class="font-16 font-weight-bold">
                {{ item.cycle_day }} DAYS
              </div>
              <div class="font-12 clr_777777">
                Duration
              </div>
            </div>
            <div class="text-center">
              <div class="font-16 font-weight-bold">
                {{ item.all_amount }}
              </div>
              <div class="font-12 clr_777777">
                max amount
              </div>
            </div>
            <div class="text-center">
              <div class="font-16 font-weight-bold">
                {{ item.rate }}%
              </div>
              <div class="font-12 clr_777777">
                interest
              </div>
            </div>
          </div>
          <van-divider />
          <div class="font-10 clr_777777 text-center">
            {{ item.remark }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MaskDialog from './Common/MaskDialog.vue'
export default {
  components: {
    MaskDialog,
  },
  data() {
    return {
      productList: [],
      is_auth: 0,
      is_repay: 0,
      is_first: 0,
      loading: false,
      userInfo: null,
      token: null,
    }
  },
  computed: {

  },
  created() {
    this.token = window.localStorage.getItem('token')
    if (this.token) {
      this.getUserInfo()
      this.getProductList()
    } else {
      this.loading = true
    }
  },
  methods: {
    getBackGroundColor(index) {
      let color;
      switch (index % 3) {
        case 0:
          color = 'background:#C0BFFF'
          break;
        case 1:
          color = 'background:#FFCBA3'
          break;
        case 2:
          color = 'background:#ACE5FF'
          break;
        default:
        color = 'background:#C0BFFF'
      }
      return color;
    },
    getColorBackGroundColor(index) {
      let color;
      switch (index % 3) {
        case 0:
          color = 'background:#726AFF'
          break;
        case 1:
          color = 'background:#FF8425'
          break;
        case 2:
          color = 'background:#ACE5FF'
          break;
        default:
        color = 'background:#726AFF'
      }
      return color;
    },
    apply() {
      this.$router.push({
        name: 'details'
      })
    },
    apply2(product_id) {
      this.$router.push(`/details?product_id=` + product_id)
    },
    home() {
      this.$router.push({
        name: 'index'
      })
    },
    profile() {
      if (this.userInfo.is_detail === 0) {
        this.$router.push({
          name: 'personaldetails'
        })
      } else if (this.userInfo.is_relation === 0) {
        this.$router.push({
          name: 'companydetails'
        })
      } else if (this.userInfo.is_bank === 0) {
        this.$router.push({
          name: 'bankdetails'
        })
      } else if (this.userInfo.is_auth === 0) {
        this.$router.push({
          name: 'photoproofs'
        })
      }
    },
    async getUserInfo() {
      const { data: res } = await this.$http.post('/api/user/info')
      this.loading = true
      if (res.code === 0) {
        this.is_auth = res.data.is_auth
        this.is_first = res.data.is_first
        this.is_repay = res.data.is_repay
        this.userInfo = res.data
      } else {
        this.$toast(res.msg)
      }
    },
    async getProductList() {
      const { data: res } = await this.$http.post('/api/product/productList')
      this.loading = true
      if (res.code === 0) {
        this.productList = res.data.rows
      } else {
        this.$toast(res.msg)
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#app {
  background: #FFA775;
  min-height: 100vh;
  padding: 91px 18px 40px 18px;
  box-sizing: border-box;

  .container {
    padding: 22px 20px 40px 20px;
    border-radius: 14px;
    text-align: center;
    box-sizing: border-box;

    .progress-bar-box {
      height: 12px;
      background: #FFF2EB;
      border-radius: 7px;

      .progress-bar-content {
        background: #FF5D00;
        border-radius: 7px;
        height: 12px;
      }
    }

    .common-day {
      padding: 10px 25px;
      font-size: 16px;
      line-height: 18px;
      height: 18px;
      background: #F6F6F6;
      border-radius: 19px;
    }

    .apply {
      padding: 12px 58px;
      border-radius: 24px;
      font-size: 16px;
      font-weight: bold;
      color: #FFFFFF;
      font-family: HelveticaNeue-Bold, HelveticaNeue;
      width: 87px;
    }
  }

  .repayment-box {
    border-radius: 14px 14px 0px 0px;
    padding: 20px 12px;

    .repayment-title {
      padding: 13px 14px;
      border-radius: 14px 14px 0px 0px;
    }

    .repayment-content {
      border-radius: 0px 0px 14px 14px;
      background: #FFFFFF;
      padding: 14px 19px;
    }

    .repayment-btn {
      border-radius: 18px;
      padding: 7px 11px;
    }
  }
}
</style>
